interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const ArrowRIcon = (props: PropsType) => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={props.style ? props.style : undefined}
  >
    <path d="M15 9L0 17.6603L0 0.339746L15 9Z" fill={props.color ? props.color : 'white'} />
  </svg>
);

export default ArrowRIcon;
